<div class="container-fluid">
    <div class="row">
        <div class="col-2 attachment-items">
            <div class="card" *ngFor="let attachment of attachments" (click)="clickAttachment(attachment)"
                [ngClass]="{'attachment-selected': attachment.Id == selectedAttachmentFirst?.Id || attachment.Id == selectedAttachmentSecond?.Id}">
                <div class="card-header">
                    <div class="row">
                        <div class="col-auto mr-auto">
                            <div class="attachment-items-type">{{attachment.TypeName}}</div>
                        </div>
                        <div class="col col-auto">
                            <div [ngSwitch]="attachment.Id"
                                *ngIf="selectedAttachmentFirst?.Id && selectedAttachmentSecond?.Id"
                                class="attachment-selected-numberjustify-content-center align-items-center">
                                <span *ngSwitchCase="selectedAttachmentFirst.Id">G</span>
                                <span *ngSwitchCase="selectedAttachmentSecond.Id">D</span>
                                <span *ngSwitchDefault>&nbsp;</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-bodyd attachment-container">
                    <div class="row">
                        <div class="col-auto mr-auto">
                            <div class="attachment-name">{{attachment.Name}}
                                ({{attachment.CreationDate | date:'dd/MM/yyyy HH:mm:ss'}})</div>
                        </div>
                        <div class="col-auto">
                            <div class="card-footer attachment-actions">
                                <span *ngIf="(attachment.TypeId == 2 && canDeleteQuoteAttachment)
                                || (attachment.TypeId == 3 && canDeleteOrderAttachment)"
                                    class="attachment-action material-icons"
                                    (click)="deleteAttachment(attachment)">delete_forever</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-10">
            <div class="row">
                <div class="col align-self-center">
                    <div class="card pdf-viewer-container">
                        <div class="card-body" [hidden]="!selectedAttachmentFirst">
                            <div *ngIf="!isErrorFirst" class="pdf-viewer">
                                <ng2-pdfjs-viewer locale="fr-FR" [viewBookmark]="false" [openFile]="false"
                                    #pdfViewerFirst>
                                </ng2-pdfjs-viewer>
                            </div>
                            <div *ngIf="!isLoadingFirst && isErrorFirst">
                                Une erreur s'est produite lors du chargement du document. Réessayez plus tard ou
                                contactez un administrateur.
                            </div>
                        </div>
                        <div class="card-body" *ngIf="!attachments || !attachments.length">
                            Aucun document à afficher.
                        </div>
                    </div>
                </div>

                <div class="col align-self-center" [hidden]="!selectedAttachmentSecond">
                    <div class="card pdf-viewer-container">
                        <div class="card-body">
                            <div *ngIf="!isErrorFirst" class="pdf-viewer">
                                <ng2-pdfjs-viewer locale="fr-FR" [viewBookmark]="false" [openFile]="false"
                                    #pdfViewerSecond>
                                </ng2-pdfjs-viewer>
                            </div>
                            <div *ngIf="!isLoadingSecond && isErrorSecond">
                                Une erreur s'est produite lors du chargement du document. Réessayez plus tard ou
                                contactez un administrateur.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>